import { render, staticRenderFns } from "./ContactsComponent.vue?vue&type=template&id=1f0e3662&scoped=true"
import script from "./ContactsComponent.vue?vue&type=script&lang=js"
export * from "./ContactsComponent.vue?vue&type=script&lang=js"
import style0 from "./ContactsComponent.vue?vue&type=style&index=0&id=1f0e3662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0e3662",
  null
  
)

export default component.exports